<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
        <div class="card-toolbar">
            <ButtonDropdownFilter
                :btn-title="$t('label.allSellers')"
                :options="salesPersons"
                value-field="id"
                name-field="fullname"
                v-model="query.seller_id"
                :border="true"
            />
        </div>
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!getWonOpportunitiesConversionRate.total_opportunities" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="getWonOpportunitiesConversionRate.total_opportunities > 0" class="p-5">
              <div class="row">
                <div class="col-12 col-md-7 col-lg-7 d-flex justify-content-center align-items-center position-relative">
                  <canvas id="kt_chartjs_exchange_clients" class="mh-400px"></canvas>
                  <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; height: 50%; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                    <div class="text-center">
                      <h1 class="display-2">{{ getWonOpportunitiesConversionRate.total_opportunities }}</h1>
                      <span>{{$t('pipelines.total_prospects')}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center">
                  <div class="p-5" style="border: 2px solid #CCCFD3; border-radius: 8px; width: 100%;">
                    <div class="d-flex mb-15 align-items-center">
                      <span class="bg-primary px-20 py-5 me-2" style="border-radius: 5px;"></span>
                      <div class="text-start">
                        <h6>{{getWonOpportunitiesConversionRate.won_percentage+'%'}} {{$t('pipelines.which_is')}} {{getWonOpportunitiesConversionRate.won_opportunities}}</h6>
                        <span>{{ $t('pipelines.convert_client') }}</span>
                      </div>
                    </div>
                    <div class="d-flex mb-5 align-items-center">
                      <span class="px-20 py-5 me-2" style="border-radius: 5px; background-color: #c0e7fa;"></span>
                      <div class="text-start">
                        <h6>{{getWonOpportunitiesConversionRate.lost_percentage+'%'}} {{$t('pipelines.which_is')}} {{getWonOpportunitiesConversionRate.lost_opportunities}}</h6>
                        <span>{{ $t('pipelines.remain_client') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import Loader from '@/components/Loader.vue';
import { computed, watch, onMounted, shallowRef, ref} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})

const online = ref(false)

const getWonOpportunitiesConversionRate = ref([])
const chartExchangeClientRef = shallowRef(null)

const salesPersons = computed(() => store.getters['pipelines/getSalesPersons'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

watch(() => online.value, (value) => {
    query.value.status = value ? 'LOST' : 'WON'
})

function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {

          getWonOpportunitiesConversionRate.value = res?.response?.data || res?.data

        }),
        store.dispatch('pipelines/loadPipelines'),
        store.dispatch('pipelines/loadSalesPersons')
    ]).then(() => {
      chartPipeline()
    })
}

function chartPipeline() {
    let names = [];
    let counts = [];
    let colors = [];

    if(getWonOpportunitiesConversionRate.value.lost_opportunities > 0){
      names.push(i18n.global.t('pipelines.remain_client'))
      counts.push(getWonOpportunitiesConversionRate.value.lost_opportunities)
      colors.push('#0072CE66')
    }
    if(getWonOpportunitiesConversionRate.value.won_opportunities > 0){
      names.push(i18n.global.t('pipelines.convert_client'))
      counts.push(getWonOpportunitiesConversionRate.value.won_opportunities )
      colors.push('#0072CE')
    }

    if(names.length === 0 || counts.length === 0 || colors.length === 0){
      getWonOpportunitiesConversionRate.value = [];
    }

    let ctx = document.getElementById('kt_chartjs_exchange_clients');

    if (ctx) {
      if(Chart.getChart("kt_chartjs_exchange_clients")) {
        Chart.getChart("kt_chartjs_exchange_clients")?.destroy()
      }

      let context = ctx.getContext('2d');
      let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

      let config = {
        type: 'doughnut',
        data: {
          datasets: [{
            data: counts,
            backgroundColor: colors,
            borderWidth: 0
          }]
        },
        options: {
          plugins: {
            legend: {
              display: true,
              position: 'bottom'
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let percentageLabel = i18n.global.t('pipelines.count');
                  return `${percentageLabel}: ${$formatLocalAmount(context.parsed)}`;
                }
              }
            }
          },
          responsive: true,
          elements: {
            arc: {
              borderWidth: 1
            }
          },
          cutout: '80%'
        }
      };

      if (!chartExchangeClientRef.value) {
        chartExchangeClientRef.value = new Chart(ctx, config);
      } else {
        chartExchangeClientRef.value.destroy();
        chartExchangeClientRef.value = new Chart(ctx, config);
      }
    } else {
      console.error('Canvas element not found');
      return;
    }
  }

onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})
</script>